'use client';
import { getConnectors, watchConnectors, } from '@bigmi/client';
import { useSyncExternalStore } from 'react';
import { useConfig } from './useConfig.js';
export function useConnectors(parameters = {}) {
    const config = useConfig(parameters);
    return useSyncExternalStore((onChange) => watchConnectors(config, { onChange }), () => getConnectors(config), () => getConnectors(config));
}
//# sourceMappingURL=useConnectors.js.map